"use client";

/**
 * Last-resort screen for an error in the root layout itself (where
 * app/error.tsx can't help). It replaces the whole page, so it brings its own
 * <html> and plain styles.
 */
import { useEffect, useState } from "react";
import { handleBoundaryError } from "@/lib/errorReport";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [recovering, setRecovering] = useState(false);
  useEffect(() => {
    console.error("Global error boundary caught:", error);
    // eslint-disable-next-line react-hooks/set-state-in-effect -- decided once per error
    setRecovering(handleBoundaryError(error, "Global", reset));
  }, [error, reset]);

  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#F6F3FF", fontFamily: "system-ui, sans-serif", color: "#140F33" }}>
        <div style={{ maxWidth: 420, padding: 32, margin: 16, borderRadius: 28, background: "#fff", boxShadow: "0 24px 60px -24px rgba(40,20,120,.35)", textAlign: "center" }}>
          {recovering ? (
            <p style={{ fontWeight: 600 }}>Reloading the page…</p>
          ) : (
            <>
              <h1 style={{ fontSize: 22, margin: "0 0 8px" }}>Something went wrong</h1>
              <p style={{ fontSize: 14, color: "#5b5675", margin: "0 0 20px" }}>The page hit an unexpected error. It&apos;s been logged.</p>
              <button type="button" onClick={() => window.location.reload()} style={{ width: "100%", padding: "12px 16px", border: 0, borderRadius: 999, background: "#6a52ff", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
                Reload the page
              </button>
              <p style={{ fontSize: 12, color: "#8a86a3", marginTop: 16, wordBreak: "break-word" }}>{error?.message}</p>
            </>
          )}
        </div>
      </body>
    </html>
  );
}
